import { isClient, isObject, isFunction } from './utils';
import { setNativeProtocolByProductId } from './common';
import { appInfo } from './appInfo';
export var ClientInfoTokenType;
(function (ClientInfoTokenType) {
    /**
     * 未登录
     */
    ClientInfoTokenType[ClientInfoTokenType["NotLogin"] = 0] = "NotLogin";
    /**
     * 邮箱
     */
    ClientInfoTokenType[ClientInfoTokenType["Email"] = 1] = "Email";
    /**
     * 手机号
     */
    ClientInfoTokenType[ClientInfoTokenType["Phone"] = 2] = "Phone";
    /**
     * 匿名
     */
    ClientInfoTokenType[ClientInfoTokenType["Anonymous"] = 4] = "Anonymous";
    /**
     * QQ
     */
    ClientInfoTokenType[ClientInfoTokenType["QQ"] = 100] = "QQ";
    /**
     * 微博
     */
    ClientInfoTokenType[ClientInfoTokenType["Blog"] = 101] = "Blog";
    /**
     * 微信
     */
    ClientInfoTokenType[ClientInfoTokenType["Wechat"] = 102] = "Wechat";
})(ClientInfoTokenType || (ClientInfoTokenType = {}));
var clientInfoCached;
/**
 * 客户端信息
 */
export var clientInfoCache = Object.create(null);
/**
 * 更新通过getClientInfo获取的客户端信息缓存，所有key值均转换为小写，方便获取信息
 * @param info 客户端信息
 */
export function updateClientInfoCache(info) {
    Object.keys(info).map(function (key) {
        clientInfoCache[key.toLowerCase()] = info[key];
    });
}
var callbacks = [];
var pending = false;
var ymstockCallbacks = [];
var ymstockPending = false;
function flushCallbacks(clientInfo, isYmstock) {
    if (isYmstock === void 0) { isYmstock = false; }
    clientInfoCached = clientInfo;
    updateClientInfoCache(clientInfo);
    var copies;
    if (isYmstock) {
        ymstockPending = false;
        copies = ymstockCallbacks.slice(0);
        ymstockCallbacks.length = 0;
    }
    else {
        pending = false;
        copies = callbacks.slice(0);
        callbacks.length = 0;
    }
    for (var i = 0; i < copies.length; i++) {
        copies[i](clientInfo);
    }
    // 设置客户端协议
    setNativeProtocolByProductId(appInfo.productId);
}
var middleware;
function WEB_CALLBACK_APPINFO_CLIENT_INFO(clientInfo) {
    if (typeof clientInfo === 'string') {
        try {
            clientInfo = JSON.parse(clientInfo);
        }
        catch (e) {
        }
    }
    flushCallbacks(clientInfo);
    try {
        middleware && middleware(clientInfo);
    }
    catch (error) {
    }
}
/**
 * 经典版打点调用getAppInfo专用
 */
function WEB_CALLBACK_APPINFO_CLIENT_INFO2(appInfo) {
    var clientInfo;
    if (typeof appInfo === 'string') {
        try {
            clientInfo = JSON.parse(appInfo);
        }
        catch (e) {
        }
    }
    else {
        clientInfo = appInfo;
    }
    // 防止和getClientInfo的guid冲突
    clientInfo.hardwareCode = clientInfo.guid;
    delete clientInfo.guid;
    flushCallbacks(clientInfo, true);
}
if (isClient) {
    if (window.WEB_CALLBACK_APPINFO_CLIENT_INFO) {
        console.warn('WEB_CALLBACK_APPINFO_CLIENT_INFO in defined', window.WEB_CALLBACK_APPINFO_CLIENT_INFO);
        middleware = window.WEB_CALLBACK_APPINFO_CLIENT_INFO;
    }
    window.WEB_CALLBACK_APPINFO_CLIENT_INFO = WEB_CALLBACK_APPINFO_CLIENT_INFO;
    window.WEB_CALLBACK_APPINFO_CLIENT_INFO2 = WEB_CALLBACK_APPINFO_CLIENT_INFO2;
}
function normalizeOptions(options) {
    var _options = {};
    if (isObject(options)) {
        _options = options;
    }
    else if (isFunction(options)) {
        _options = {
            complete: options
        };
    }
    return _options;
}
/**
 * 获取客户端信息
 */
export function getClientInfo(options) {
    var _options = normalizeOptions(options);
    _options = Object.assign({
        forceUpdate: true
    }, _options);
    if (isClient && window.goods && (_options.callGetAppInfo ? window.goods.getAppInfo : window.goods.getClientInfo)) {
        var _resolve_1;
        var _callback = function (clientInfo) {
            if (_options.success) {
                try {
                    _options.success(clientInfo);
                }
                catch (error) {
                    console.error('[goods.getClientInfo]: ', _options.success.toString(), error);
                }
            }
            _options.complete && _options.complete(clientInfo);
            _resolve_1(clientInfo);
        };
        if (_options.callGetAppInfo) {
            ymstockCallbacks.push(_callback);
            // 经典版专用
            if (!ymstockPending) {
                ymstockPending = true;
                if (clientInfoCached && !_options.forceUpdate) {
                    setTimeout(function () { return flushCallbacks(clientInfoCached); }, 0);
                }
                else {
                    try {
                        var appInfoResult_1;
                        try {
                            appInfoResult_1 = window.goods.getAppInfo(JSON.stringify({
                                callback: 'WEB_CALLBACK_APPINFO_CLIENT_INFO2'
                            }));
                        }
                        catch (e) {
                            appInfoResult_1 = window.goods.getAppInfo();
                        }
                        if (appInfoResult_1) {
                            setTimeout(function () { return WEB_CALLBACK_APPINFO_CLIENT_INFO2(appInfoResult_1); }, 0);
                        }
                    }
                    catch (error) {
                        console.error('[goods.getClientInfo]: ', error);
                    }
                }
            }
        }
        else {
            callbacks.push(_callback);
            if (!pending) {
                pending = true;
                if (clientInfoCached && !_options.forceUpdate) {
                    setTimeout(function () { return flushCallbacks(clientInfoCached); }, 0);
                }
                else {
                    try {
                        window.goods.getClientInfo('WEB_CALLBACK_APPINFO_CLIENT_INFO');
                    }
                    catch (error) {
                        console.error('[goods.getClientInfo]: ', error);
                    }
                }
            }
        }
        return new Promise(function (resolve) {
            _resolve_1 = resolve;
        });
    }
    else {
        var errorText = 'goods is undefined';
        if (_options.error) {
            try {
                _options.error(errorText);
            }
            catch (error) {
                console.error('[goods.getClientInfo]: ', _options.error.toString(), error);
            }
        }
        _options.complete && _options.complete();
        if (!_options.success && !_options.error && !_options.complete) {
            return Promise.reject(errorText);
        }
    }
}
//# sourceMappingURL=getClientInfo.js.map